
<template>
    <div class="signUp bodyfont-unauth" v-if="this.error.message === 'User.Does.Not.Exist'">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="row margin-top">
                        <div class="col-md-7">
                            <div class="main-content text-left left-content">
                                <hr>
                                <h2 v-if="getCorporateClient">
                                    {{getGiftee.welcomeMessage}}
                                    <!--<span v-if="getCorporateClientId === '50'">Welcome, Ann Carlsen has given you a 12 Month Membership to TONE Networks. Enjoy your Gift.</span>-->
                                    <!--<span v-else>Welcome, You have received a gift from {{getCorporateClient.name}}.</span>-->
                                </h2>
                            </div>
                            <div class="left-content">
                                <accordion :one-at-atime="true">
                                    <panel :is-open="true"  class="text-left">
                                        <h4>Create your Account</h4>
                                        <!--<h4>Start your Trial. Setup your Account</h4>-->
                                        <div class="create-account">
                                            <br>
                                            <div class="form">
                                                <form  method="post"  v-on:submit.prevent="onGifteeSubmit">

                                                    <div class="responsive-table">
                                                        <table>
                                                            <tbody>
                                                            <tr>
                                                                <td class="td1">First Name:</td>
                                                                <td>{{ user.firstName }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="td1">Last Name</td>
                                                                <td>{{ user.lastName }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="td1">Email</td>
                                                                <td>{{ user.email }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                        <checkbox class="terms-and-condition" v-model="isChecked" value="isChecked" type="primary">
                                                            &nbsp;I agree to <a href="/terms" target="_blank" rel="opener" :style="{color: getCorpHeaderColor}">terms and conditions</a>
                                                        </checkbox>

                                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center padding-minus padding-minus-right">
                                                        <!--<button class="btn formButton btn-block" type="submit" id="signup_button" :disabled="isUserLoggedIn">-->
                                                        <button v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor, borderWidth: '1px !important', borderStyle: 'solid !important', borderColor: this.getCorpButtonColor + ' !important'}" class="btn formButton btn-block" type="submit" id="redeem_button"  :disabled = "!isChecked || spinner || this.user.packageId === -1">
                                                            Complete Sign Up
                                                            <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </panel>
                                </accordion>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="right-content">
                                <div class="jumbotron" v-bind:style="{ backgroundColor: getCorpButtonColor}">
<!--                                    <div v-if="getGiftee.panelHeading1"><h2>{{getGiftee.panelHeading1}}</h2></div>&ndash;&gt;-->
                                    <div class="hidemobile"><h2 v-if="getGiftee.panelHeading1">{{getGiftee.panelHeading1}}</h2><p v-if="getGiftee.panelHeading2">{{getGiftee.panelHeading2}}</p></div>
                                    <div class="showmobile"><h2 v-if="getGiftee.panelHeading2">{{getGiftee.panelHeading2}}</h2></div>
                                </div>
                            </div>
                            <div class="right-content">
                                <div class="card">
                                    <div class="card-block">
                                        <div class="list-group">
                                            <li v-if="getGiftee.panelBullet1" v-html="getGiftee.panelBullet1">
                                                <!--Personalized bite-sized expert-->
                                                <!--videos will inspire you and set a positive-->
                                                <!--TONE to your day-->
                                            </li>
                                            <li  v-if="getGiftee.panelBullet2" v-html="getGiftee.panelBullet2">
                                                <!--A little dose of humor, and a pinch-->
                                                <!--of inspiration each time you log on.-->
                                            </li>
                                            <li v-if="getGiftee.panelBullet3" v-html="getGiftee.panelBullet3">
                                                <!--Reserve your spot for TONE Live...-->
                                                <!--Exclusive live streaming events with our-->
                                                <!--credentialed experts.-->
                                            </li>
                                            <li v-if="getGiftee.panelBullet4" v-html="getGiftee.panelBullet4">
                                                <!--Tune in to TONE Talks...our moderated-->
                                                <!--discussions every Tuesday and Thursday night-->
                                                <!--where we share advice within our community-->
                                                <!--of women helping women!-->
                                            </li>
                                            <li v-if="getGiftee.panelBullet5" v-html="getGiftee.panelBullet5">
                                                <!--Most importantly, make time for you!-->
                                            </li>
                                            <li v-if="getGiftee.panelBullet6" v-html="getGiftee.panelBullet6">
                                                <!--Enjoy your gift!-->
                                            </li>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="card-footer hidemobile" >
                                        <div class="list-group">
                                            <li class="list-group-item" v-if="giftDescription">
                                                <strong>{{giftDescription}}</strong>
                                                <!--<input type="radio" name = "pkg" :value="defaultPlan.packageId" v-model="packageId" :checked="defaultPlan.packageId == packageId" />&nbsp;&nbsp;<strong>{{ defaultPlan.type }}</strong> (${{defaultPlan.amount}}) - {{defaultPlan.description}}-->
                                            </li>
                                            <!-- li class="list-group-item" v-else>
                                                <strong>{{defaultPlan.description}}</strong>
                                            </li -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal v-if="showResetModal" class="watchVideoModal" effect="zoom" :value="showResetModal" @cancel="cancelResetModal()" width="200">
            <div slot="modal-header" class="watchVideoModalHeader">
                <a>
                    <img src="../assets/logo.svg" alt="LOGO">
                </a>
                <a v-a11y-action href="javascript:" @click="cancelResetModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">


                <div class="text-center">
                    <h2 class="forgot-heading">
                        That Account Exists!
                    </h2>
                    <p><strong>You have an account with Tone Networks. Please try logging in.</strong></p>
                    <button class="btn formButton btn-transparent" @click="SetupLogin">
                        Sign In
                    </button>
                </div>
            </div>
            <div slot="modal-footer">
            </div>
        </modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { accordion, dropdown, radio, tab, buttonGroup } from 'vue-strap'
    import spinner from '@/accessibility/Spinner'
    import panel from '@/accessibility/Panel'
    import alert from '@/accessibility/Alert'
    import tabs from '@/accessibility/Tabs'
    import input from '@/accessibility/Input'
    import checkbox from '@/accessibility/Checkbox'
    import modal from '@/accessibility/Modal'
    import MaskedInput from 'vue-masked-input'
    import store from '../store'
    import $ from 'jquery'
    export default {
        components: {
            'bs-input': input,
            'spinner': spinner,
            'accordion': accordion,
            'panel': panel,
            'masked-input': MaskedInput,
            alert,
            dropdown,
            radio,
            checkbox,
            tabs,
            tab,
            buttonGroup,
            modal
        },
        name: 'signUp',
        metaInfo () {
            return {
                title: 'TONE | Redeem Your Gift',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Redeem Your Gift'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Redeem Your Gift'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                user: {
                    userId: 0,
                    accountId: 0,
                    email: '',
                    firstName: '',
                    lastName: '',
                    packageId: 9,
                    corporationId: 200,
                    comments: 'HORIZON',
                    phoneNumber: '',
                    picture: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/Sneakers.png'

                },
                info: {
                    email: '',
                    password: ''
                },
                emailPattern: "^[a-zA-Z0-9._%+'\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}(\\.[a-zA-Z]{2,})?$",
                showMobileFlag: true,
                phoneNumber: '',
                rawPhoneNumber: '',
                spinner: false,
                alert: false,
                paymentSection: false,
                isToggle: false,
                isChecked: false,
                defaultPlan: '',
                // corpGiftCode: this.$route.params.giftCode,   // commented on 03/25/2025
                // corpId: this.$route.params.corporateId,      // commented on 03/25/2025
                // userdata: this.$route.params.userdata,
                dynamic_bullet_1: '',
                dynamic_bullet_2: '',
                dynamic_bullet_3: '',
                dynamic_bullet_4: '',
                dynamic_bullet_5: '',
                dynamic_bullet_6: '',
                giftDescription: '',
                showResetModal: false,
                //
                //
                corpGiftCode: 'HORIZON',
                corpId: 200,
                base64Data: this.$route.params.userdata,
                userExistsMessage: '',
                event_corporation_id: '',
                event_redirect_uri: ''
            }
        },
        mounted () {
            var self = this
            console.log('111===========================> mounted () = ')
            // console.log('===========================> getSamlResponseFromForm = ', this.getSamlResponseFromForm())
            console.log('222===========================> mounted () base64Data =', this.base64Data)
            //
            if (localStorage.getItem('event_corporation_id')) {
                this.event_corporation_id = localStorage.getItem('event_corporation_id')
                // this.event_corporation_id = this.$getLocalStorageValueWithCheck('event_corporation_id')
                // console.log('=============================> this.$getLocalStorageValueWithCheck(event_corporation_id)', this.event_corporation_id)
            }
            if (localStorage.getItem('event_redirect_uri')) {
                this.event_redirect_uri = localStorage.getItem('event_redirect_uri')
                // this.event_redirect_uri = this.$getLocalStorageValueWithCheck('event_redirect_uri')
                // console.log('=============================> this.$getLocalStorageValueWithCheck(event_redirect_uri)', this.event_redirect_uri)
            }
            //
            let giftPayload = []
            giftPayload.push(this.corpGiftCode)
            giftPayload.push(this.corpId)
            // if (this.$route.params.giftCode && this.$route.params.corporateId) {
            if (this.corpGiftCode && this.corpId) {
                this.$store.commit('setCorporateGiftingCode', {giftCode: this.corpGiftCode})
                this.$store.commit('setCorporateClientId', {corporateClientId: this.corpId})
            } else {
                this.$router.push('/')
            }
            console.log('GETCORPORATECLIENT===================================> this.corpId = ', this.corpId)
            console.log('GETCORPORATECLIENT===================================> giftPayload = ', giftPayload)
            self.$store.dispatch('GETCORPORATECLIENT', self.corpId).then(() => {
                if (self.getCorporateClient) {
                    console.log('GETCORPORATECLIENT: this.getCorporateClient', this.getCorporateClient)
                }
            })
            self.$store.dispatch('GETCORPORATIONGIFTEE', giftPayload).then(() => {
                if (this.getGiftee) {
                    console.log('giftee info', this.getGiftee)
                    this.$store.commit('setCorporateGiftInfo', {gift: this.getGiftee})
                    // this.user.firstName = this.getGiftee.gifteeFirstName  // commented on 03/25/2025
                    // this.user.lastName = this.getGiftee.gifteeLastName   // commented on 03/25/2025
                    // this.user.email = this.getGiftee.gifteeEmail         // commented on 03/25/2025
                    this.user.packageId = this.getGiftee.packageId
                    this.user.comments = this.getGiftee.gifteeUuid
                    this.giftDescription = this.getGiftee.signupGiftDesc
                } else {
                    if (this.getGiftingError.show) {
                        this.user.packageId = -1
                        this.$swal({
                            title: 'No gift found for this corporation. Please contact your administrator.',
                            text: '',
                            type: 'error',
                            timer: 4000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    }
                }
                this.$store.dispatch('GETPLANS').then(() => {
                    let plan = this.getAllPlans.filter(pln => {
                        return pln.packageId === this.getGiftee.packageId
                    })
                    this.defaultPlan = plan[0]
                })
                this.$store.dispatch('GETPLAN', this.user.packageId).then(() => {
                    this.defaultPlan = this.getDefaultPlan
                })
            })
            //
            if (self.$route.params.userdata && this.$route.params.userdata) {
                console.log('2 ====================> Starting Prococessing SAML Attributes ::: ')
                // this.$store.commit('setCorporateGiftingCode', {giftCode: this.$route.params.giftCode})
                // this.$store.commit('setCorporateClientId', {corporateClientId: this.$route.params.corporateId})
                self.base64Data = self.$route.params.userdata
                console.log('3 ====================> INSIDE extractSamlAttributes() ::: ')
                self.$store.dispatch('DECODE_REQUEST_DATA', this.base64Data).then((response) => {
                    console.log('4 ====================> INSIDE extractSamlAttributes() ::: ')
                    // console.log('4A====================> INSIDE extractSamlAttributes() ::: this.decodedData = ', this.decodedData) // undefined
                    console.log('4B====================> INSIDE extractSamlAttributes() ::: this.getRequestDecodedData = ', this.getRequestDecodedData)
                    // console.log('4C====================> INSIDE extractSamlAttributes() ::: this.requestDecodedData = ', this.requestDecodedData) // undefined
                    // let self = this
                    if (this.getRequestDecodedData) {
                        console.log('5 ====================> INSIDE extractSamlAttributes() ::: ')
                        console.log('====================> INSIDE extractSamlAttributes() ::: this.getRequestDecodedData = ', this.getRequestDecodedData)
                        //
                        this.user.email = this.getRequestDecodedData.email
                        this.user.firstName = this.getRequestDecodedData.firstName
                        this.user.lastName = this.getRequestDecodedData.lastName
                        this.user.accountId = this.getRequestDecodedData.username
                        // this.user.packageId = '9'
                        // this.user.corporationId = this.getRequestDecodedData.corporationId
                        // this.user.comments = this.getRequestDecodedData.comments
                        //
                        //
                        console.log('====================> INSIDE extractSamlAttributes() ::: this.user.email = ', this.user.email)
                        console.log('====================> INSIDE extractSamlAttributes() ::: tthis.user.firstName = ', this.user.firstName)
                        console.log('====================> INSIDE extractSamlAttributes() ::: this.user.lastName = ', this.user.lastName)
                        console.log('====================> INSIDE extractSamlAttributes() ::: this.user.username = ', this.user.username)
                        console.log('====================> INSIDE extractSamlAttributes() ::: this.user.comments = ', this.user.comments)
                        console.log('====================> INSIDE extractSamlAttributes() ::: this.user.username (account id) = ', this.user.username)
                        console.log('====================> INSIDE extractSamlAttributes() ::: this.user.corporationId = ', this.user.corporationId)
                        //
                        //
                        var self = this
                        // localStorage.setItem('requestDecodedData', JSON.stringify(this.requestDecodedData))
                        console.log('333===========================> mounted () this.user.email = ', this.user.email)
                        //
                        self.$store.dispatch('CHECKUSEREXISTS', {email: this.user.email}).then(() => {
                            // self.spinnerToggle()
                            console.log('===================================> this.error.message this.user.email= ', this.user.email)
                            console.log('===================================> this.error.message = ', this.error.message)
                            console.log('1===================================> this.error.show = ', this.error.show)
                            console.log('1===================================> this.error.message = >>>', this.error.message)
                            console.log('1===================================> this.info.email = ', this.info.email)
                            console.log('1===================================> this.info.password = >>>', this.info.password)
                            //
                            if (self.error.show === false) { // false = user found
                                console.log('2===================================> this.error.show = ', self.error.show)
                                this.userExistsMessage = this.error.message // blank if return user
                                // this.spinnerToggle()
                                //
                                this.info.email = this.user.email
                                this.info.password = ''
                                //
                                if (self.isUserLoggedIn && self.isUserLoggedIn.userId > 0) {
                                    console.log('user is logged in')
                                    //
                                    var loggedinUserEmail = self.isUserLoggedIn.email
                                    console.log('3A===================================> loggedinUserEmail = ', loggedinUserEmail)
                                    //
                                    if (loggedinUserEmail.toLowerCase() === this.user.email.toLowerCase()) {
                                        console.log('4===================================> loggedinUserEmail === this.user.email. So redirecting to /corporation/mycommunity')
                                        if (this.event_corporation_id !== '' && this.event_redirect_uri !== '') {
                                            // Remove any trailing slash
                                            this.event_redirect_uri = this.event_redirect_uri.replace(/\/$/, '')
                                            // Extract the part after the last slash
                                            const parts = this.event_redirect_uri.split('/')
                                            let eventId = parts[parts.length - 1]
                                            console.log('4A===================================>  EVENT ID = ', eventId)
                                            //
                                            this.$router.push('/event/' + eventId)
                                            if (localStorage.getItem('event_corporation_id')) {
                                                localStorage.removeItem('event_corporation_id')
                                            }
                                            if (localStorage.getItem('event_redirect_uri')) {
                                                localStorage.removeItem('event_redirect_uri')
                                            }
                                        } else {
                                            this.$router.push('/corporation/mycommunity')
                                        }
                                    } else {
                                        console.log('4===================================> loggedinUserEmail <> this.user.email. LOGGING OUT')
                                        self.$store.dispatch('LOGOUTHORIZON', self.isUserLoggedIn)
                                    }
                                }
                                //
                                if (!self.isUserLoggedIn) { // added 0n 05/02/2025
                                    self.$store.dispatch('LOGIN', {user: self.info}).then(() => {
                                        // self.spinnerToggle()
                                        if (!self.error.show) {
                                            if ($(window).width() > 739) {
                                            } else {
                                                let self = this
                                                var eventDesc
                                                this.$store.dispatch('GETEVENTLIST').then(() => {
                                                    if (this.getEventList) {
                                                        let currentDate = this.returnEasternTime()
                                                        let eMonth = currentDate.getMonth() + 1
                                                        eMonth = eMonth >= 10 ? eMonth : `0${eMonth}`
                                                        let eDate = currentDate.getDate() >= 10 ? currentDate.getDate() : `0${currentDate.getDate()}`
                                                        let formattedDate = `${eMonth}/${eDate}/${currentDate.getFullYear()}`
                                                        // Get Events on given Day
                                                        let eventsOnDate = this.getEventList.filter(ev => {
                                                            return ev.start_date.substr(0, 10) === formattedDate
                                                        })
                                                        // Get Events other than current Day
                                                        let eventsNotOnDate = this.getEventList.filter(ev => {
                                                            return new Date(ev.start_date.substr(0, 10)) > new Date(formattedDate)
                                                        })
                                                        if (eventsOnDate && eventsOnDate.length > 0) {
                                                            if (this.isEventToday(eventsOnDate[0].end_date)) {
                                                                let eventTime = new Date(eventsOnDate[0].start_date)
                                                                let eventHrs = this.getHoursFormatted(eventTime)
                                                                this.$store.dispatch('SETBANNEREVENT', eventsOnDate[0].eventId).then(() => {
                                                                })
                                                                if (eventsOnDate[0].type === '1') {
                                                                    eventDesc = `Join us for TONE Live at ${eventHrs} ET`
                                                                    this.eventDescription = eventsOnDate[0].unAuthBannerText
                                                                } else {
                                                                    eventDesc = `Join us for TONE Talks at ${eventHrs} ET`
                                                                    this.eventDescription = eventsOnDate[0].unAuthBannerText
                                                                }
                                                                if (self.currentRoute.name === 'Hello') {
                                                                    if (self.user && self.user.corporation == null) { // Regular user
                                                                        self.$swal({
                                                                            background: '#44bda8',
                                                                            title: '',
                                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                            text: '',
                                                                            type: null,
                                                                            timer: 5000,
                                                                            showConfirmButton: true,
                                                                            showCloseButton: true,
                                                                            showCancelButton: false,
                                                                            confirmButtonColor: '#f0617d',
                                                                            confirmButtonText:
                                                                                'Find out more'
                                                                        }).then(
                                                                            function () {
                                                                                self.JoinEventOrRedirect()
                                                                            },
                                                                            // handling the promise rejection
                                                                            function (dismiss) {
                                                                                if (dismiss === 'timer') {
                                                                                }
                                                                            }
                                                                        )
                                                                    } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                                                        self.$swal({
                                                                            background: '#44bda8',
                                                                            title: '',
                                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                            text: '',
                                                                            type: null,
                                                                            timer: 5000,
                                                                            showConfirmButton: true,
                                                                            showCloseButton: true,
                                                                            showCancelButton: false,
                                                                            confirmButtonColor: '#f0617d',
                                                                            confirmButtonText:
                                                                                'Find out more'
                                                                        }).then(
                                                                            function () {
                                                                                self.JoinEventOrRedirect()
                                                                            },
                                                                            // handling the promise rejection
                                                                            function (dismiss) {
                                                                                if (dismiss === 'timer') {
                                                                                }
                                                                            }
                                                                        )
                                                                    } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                                                        self.$swal({
                                                                            background: '#44bda8',
                                                                            title: '',
                                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                                            text: '',
                                                                            type: null,
                                                                            timer: 5000,
                                                                            showConfirmButton: true,
                                                                            showCloseButton: true,
                                                                            showCancelButton: false,
                                                                            confirmButtonColor: '#f0617d',
                                                                            confirmButtonText:
                                                                                'Find out more'
                                                                        }).then(
                                                                            function () {
                                                                                self.$router.push('/corporation/mycommunity')
                                                                            },
                                                                            // handling the promise rejection
                                                                            function (dismiss) {
                                                                                if (dismiss === 'timer') {
                                                                                }
                                                                            }
                                                                        )
                                                                    } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                                                        self.$swal({
                                                                            background: '#44bda8',
                                                                            title: '',
                                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                                            text: '',
                                                                            type: null,
                                                                            timer: 5000,
                                                                            showConfirmButton: true,
                                                                            showCloseButton: true,
                                                                            showCancelButton: false,
                                                                            confirmButtonColor: '#f0617d',
                                                                            confirmButtonText:
                                                                                'Find out more'
                                                                        }).then(
                                                                            function () {
                                                                                self.$router.push(self.user.corporation.bnrCustomMsgUrl)
                                                                            },
                                                                            // handling the promise rejection
                                                                            function (dismiss) {
                                                                                if (dismiss === 'timer') {
                                                                                }
                                                                            }
                                                                        )
                                                                    }
                                                                } else {

                                                                }
                                                            } else {
                                                                // Display next event in queue
                                                                if (eventsNotOnDate && eventsNotOnDate.length > 0) {
                                                                    // let formattedDate = this.getDateReference(eventsNotOnDate[0].start_date, 'event')
                                                                    this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {
                                                                    })
                                                                    if (eventsNotOnDate[0].type === '1') {
                                                                        this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                                        this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                                    } else {
                                                                        this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                                        this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                                    }
                                                                    eventDesc = this.eventDescription
                                                                    if (self.currentRoute.name === 'Hello') {
                                                                        if (self.user && self.user.corporation == null) { // Regular user
                                                                            self.$swal({
                                                                                background: '#44bda8',
                                                                                title: '',
                                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                                text: '',
                                                                                type: null,
                                                                                timer: 5000,
                                                                                showConfirmButton: true,
                                                                                showCloseButton: true,
                                                                                showCancelButton: false,
                                                                                confirmButtonColor: '#f0617d',
                                                                                confirmButtonText:
                                                                                    'Find out more'
                                                                            }).then(
                                                                                function () {
                                                                                    self.JoinEventOrRedirect()
                                                                                },
                                                                                // handling the promise rejection
                                                                                function (dismiss) {
                                                                                    if (dismiss === 'timer') {
                                                                                    }
                                                                                }
                                                                            )
                                                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                                                            self.$swal({
                                                                                background: '#44bda8',
                                                                                title: '',
                                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                                text: '',
                                                                                type: null,
                                                                                timer: 5000,
                                                                                showConfirmButton: true,
                                                                                showCloseButton: true,
                                                                                showCancelButton: false,
                                                                                confirmButtonColor: '#f0617d',
                                                                                confirmButtonText:
                                                                                    'Find out more'
                                                                            }).then(
                                                                                function () {
                                                                                    self.JoinEventOrRedirect()
                                                                                },
                                                                                // handling the promise rejection
                                                                                function (dismiss) {
                                                                                    if (dismiss === 'timer') {
                                                                                    }
                                                                                }
                                                                            )
                                                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                                                            self.$swal({
                                                                                background: '#44bda8',
                                                                                title: '',
                                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                                                text: '',
                                                                                type: null,
                                                                                timer: 5000,
                                                                                showConfirmButton: true,
                                                                                showCloseButton: true,
                                                                                showCancelButton: false,
                                                                                confirmButtonColor: '#f0617d',
                                                                                confirmButtonText:
                                                                                    'Find out more'
                                                                            }).then(
                                                                                function () {
                                                                                    self.$router.push('/corporation/mycommunity')
                                                                                },
                                                                                // handling the promise rejection
                                                                                function (dismiss) {
                                                                                    if (dismiss === 'timer') {
                                                                                    }
                                                                                }
                                                                            )
                                                                        } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                                                            self.$swal({
                                                                                background: '#44bda8',
                                                                                title: '',
                                                                                html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                                                text: '',
                                                                                type: null,
                                                                                timer: 5000,
                                                                                showConfirmButton: true,
                                                                                showCloseButton: true,
                                                                                showCancelButton: false,
                                                                                confirmButtonColor: '#f0617d',
                                                                                confirmButtonText:
                                                                                    'Find out more'
                                                                            }).then(
                                                                                function () {
                                                                                    self.$router.push(self.user.corporation.bnrCustomMsgUrl)
                                                                                },
                                                                                // handling the promise rejection
                                                                                function (dismiss) {
                                                                                    if (dismiss === 'timer') {
                                                                                    }
                                                                                }
                                                                            )
                                                                        }
                                                                    } else {
                                                                    }
                                                                }
                                                            }
                                                        } else {
                                                            // Display other event in queue
                                                            if (eventsNotOnDate && eventsNotOnDate.length > 0) {
//                                                let formattedDate = this.getDateReference(eventsNotOnDate[0].start_date, 'event')
                                                                this.$store.dispatch('SETBANNEREVENT', eventsNotOnDate[0].eventId).then(() => {
                                                                })
                                                                if (eventsNotOnDate[0].type === '1') {
                                                                    this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                                    this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                                } else {
                                                                    this.eventDescription = eventsNotOnDate[0].unAuthBannerText
                                                                    this.authEventDescription = eventsNotOnDate[0].authBannerText
                                                                }
                                                                eventDesc = this.eventDescription
                                                                if (self.currentRoute.name === 'Hello') {
                                                                    if (self.user && self.user.corporation == null) { // Regular user
                                                                        self.$swal({
                                                                            background: '#44bda8',
                                                                            title: '',
                                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                            text: '',
                                                                            type: null,
                                                                            timer: 5000,
                                                                            showConfirmButton: true,
                                                                            showCloseButton: true,
                                                                            showCancelButton: false,
                                                                            confirmButtonColor: '#f0617d',
                                                                            confirmButtonText:
                                                                                'Find out more'
                                                                        }).then(
                                                                            function () {
                                                                                self.JoinEventOrRedirect()
                                                                            },
                                                                            // handling the promise rejection
                                                                            function (dismiss) {
                                                                                if (dismiss === 'timer') {
                                                                                }
                                                                            }
                                                                        )
                                                                    } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 1) {
                                                                        self.$swal({
                                                                            background: '#44bda8',
                                                                            title: '',
                                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + eventDesc + ' </span>',
                                                                            text: '',
                                                                            type: null,
                                                                            timer: 5000,
                                                                            showConfirmButton: true,
                                                                            showCloseButton: true,
                                                                            showCancelButton: false,
                                                                            confirmButtonColor: '#f0617d',
                                                                            confirmButtonText:
                                                                                'Find out more'
                                                                        }).then(
                                                                            function () {
                                                                                self.JoinEventOrRedirect()
                                                                            },
                                                                            // handling the promise rejection
                                                                            function (dismiss) {
                                                                                if (dismiss === 'timer') {
                                                                                }
                                                                            }
                                                                        )
                                                                    } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 2) {
                                                                        self.$swal({
                                                                            background: '#44bda8',
                                                                            title: '',
                                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.corpEvent.authBannerText + ' </span>',
                                                                            text: '',
                                                                            type: null,
                                                                            timer: 5000,
                                                                            showConfirmButton: true,
                                                                            showCloseButton: true,
                                                                            showCancelButton: false,
                                                                            confirmButtonColor: '#f0617d',
                                                                            confirmButtonText:
                                                                                'Find out more'
                                                                        }).then(
                                                                            function () {
                                                                                self.$router.push('/corporation/mycommunity')
                                                                            },
                                                                            // handling the promise rejection
                                                                            function (dismiss) {
                                                                                if (dismiss === 'timer') {
                                                                                }
                                                                            }
                                                                        )
                                                                    } else if (self.user && self.user.corporation && self.user.corporation.enableCorporatePage === 1 && self.user.corporation.bnrLinkState === 3) {
                                                                        self.$swal({
                                                                            background: '#44bda8',
                                                                            title: '',
                                                                            html: '<span style="color: #fff;padding-top:30px;font-size:24px;">' + self.user.corporation.bnrCustomMsg + ' </span>',
                                                                            text: '',
                                                                            type: null,
                                                                            timer: 5000,
                                                                            showConfirmButton: true,
                                                                            showCloseButton: true,
                                                                            showCancelButton: false,
                                                                            confirmButtonColor: '#f0617d',
                                                                            confirmButtonText:
                                                                                'Find out more'
                                                                        }).then(
                                                                            function () {
                                                                                self.$router.push(self.user.corporation.bnrCustomMsgUrl)
                                                                            },
                                                                            // handling the promise rejection
                                                                            function (dismiss) {
                                                                                if (dismiss === 'timer') {
                                                                                }
                                                                            }
                                                                        )
                                                                    }
                                                                } else {

                                                                }
                                                            }
                                                        }
                                                    }
                                                })
                                            }
                                        }
                                        if (self.error.show && self.error.originalMessage !== 'aws.cognito.UserNotConfirmed') {
                                            self.$swal({
                                                title: self.error.message,
                                                text: '',
                                                type: 'error',
                                                timer: 2000,
                                                showCancelButton: false,
                                                showConfirmButton: false
                                            }).then(
                                                function () {
                                                },
                                                // handling the promise rejection
                                                function (dismiss) {
                                                    if (dismiss === 'timer') {
                                                    }
                                                }
                                            )
                                        } else if (self.error.show && self.error.originalMessage === 'aws.cognito.UserNotConfirmed') {
                                            self.$swal({
                                                title: 'Validate Your Email Address',
                                                text: 'We have already sent you a validation email. Do you want us to resend it?',
                                                type: 'error',
                                                showCancelButton: true,
                                                confirmButtonText: 'Yes, Please',
                                                cancelButtonText: 'Cancel',
                                                confirmButtonClass: 'btn btn-success',
                                                cancelButtonClass: 'btn btn-danger',
                                                buttonsStyling: false
                                            }).then(function (result) {
                                                self.$store.dispatch('RESENDVALIDATIONCODE', self.info.email).then(() => {
                                                    self.$swal({
                                                        title: 'Check your mailbox for new validation email',
                                                        text: '',
                                                        type: 'success',
                                                        timer: 3000,
                                                        showCancelButton: false,
                                                        showConfirmButton: false
                                                    }).then(
                                                        function () {
                                                        },
                                                        // handling the promise rejection
                                                        function (dismiss) {
                                                            if (dismiss === 'timer') {
                                                            }
                                                        }
                                                    )
                                                    self.cancelModal()
                                                })
                                            }, function (dismiss) {
                                            })
                                        } else {
                                            self.cancelModal()
                                            // self.spinnerToggle()
                                        }
                                    })  // self.$store.dispatch('LOGIN', {user: this.info}).then(()
                                } // end of if (!self.isUserLoggedIn) { // added 0n 05/02/2025
                            } else { // else of if (!this.error.show) { = // else of false = user found
                                // USER NOT FOUND SECTION
                                console.log('999 ====================> else of if (!this.error.show) { ::: ')

                                console.log('4===================================> loggedinUserEmail <> this.user.email.')
                                // sessionStorage.removeItem
                                if (self.isUserLoggedIn && self.isUserLoggedIn.userId > 0) {
                                    console.log('user is logged in. LOGGING OUT : self.isUserLoggedIn = ', self.isUserLoggedIn)
                                    self.$store.dispatch('LOGOUTHORIZON', self.isUserLoggedIn)
                                }
                                //
                                console.log('GETDYNAMICCONTENTS  ====================> self.corpId = ', self.corpId)
                                self.$store.dispatch('GETDYNAMICCONTENTS', 4).then(() => {
                                    if (this.getAllSiteContents) {
                                        this.dynamic_bullet_1 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_1')
                                        this.dynamic_bullet_2 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_2')
                                        this.dynamic_bullet_3 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_3')
                                        this.dynamic_bullet_4 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_4')
                                        this.dynamic_bullet_5 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_5')
                                        this.dynamic_bullet_6 = this.setDynamicSection(this.getAllSiteContents, 'BULLET_6')
                                    }
                                })
                            }  // USER NOT EXISTS
                        }).then(  // --------------------------> self.$store.dispatch('CHECKUSEREXISTS', {email: this.user.email}).then(() => {
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    } else {  // -------------------->  if (this.getRequestDecodedData) {
                        console.error('6 ====================> ELSE PART OF getRequestDecodedData IS NULL ::: ')
                        this.user.packageId = -1
                        this.$swal({
                            title: 'NO ASSERTION IS FOUND.',
                            text: '',
                            type: 'error',
                            timer: 4000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    }
                })      // -----------------------> self.$store.dispatch('DECODE_REQUEST_DATA', this.base64Data).then((response) => {
            } else {   // ---------------------> if (self.$route.params.userdata && this.$route.params.userdata) {
                console.error('7 ====================> SamlAttributes() ::: no userdata ')
                // this.$router.push('/')
            }
        },
        methods: {
            SetupLogin () {
                this.showResetModal = false
                store.commit('setTriggerLogin', {loginStatus: true})
            },
            cancelResetModal () {
                $('html').removeClass('model-open')
                // var self = this
                window.setTimeout(function () {
                    this.showResetModal = false
                    $('.modal-open').removeClass('modal-open')
                }, 500)
            },
            onSubmitForgetRequest () {
                // var self = this
                console.log('email', this.user.email)
                // this.spinnerToggle()
            },
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            // spinnerToggle () {
            //     this.spinner = !this.spinner
            // },
            verifyPaymentSubmit () {
                if (this.user.packageId > 0) {
                    return false
                }
                return true
            },
            verifyEmail () {
                if (this.user.email.length > 0) {
                    // let re = /^[\w\d.+-]+@[\w\d-]+\.[a-z]+$/i
                    let re = /^[\w\d.+'-]+@[\w\d-]+(\.[\w\d-]+)*\.[a-z]+$/i
                    if (!re.test(this.user.email)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyFirstName () {
                if (this.user.firstName.length > 0) {
                    let re = /^[A-Za-z '-]+$/
                    if (!re.test(this.user.firstName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyLastName () {
                if (this.user.lastName.length > 0) {
                    let re = /^[A-Za-z '-]+$/
                    if (!re.test(this.user.lastName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            verifyCardHolderName () {
                if (this.user.cardHolderName.length > 0) {
                    let re = /^[A-Za-z ]+$/
                    if (!re.test(this.user.cardHolderName)) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }
            },
            onGifteeSubmit () {
                if (this.rawPhoneNumber.toString().indexOf('_') === -1) {
                    this.user.phoneNumber = this.phoneNumber
                } else {
                    this.phoneNumber = ''
                    this.user.phoneNumber = ''
                }
                let giftPayload = []
                giftPayload.push(this.corpGiftCode)
                giftPayload.push(this.corpId)
                let displayMsg = 'Welcome To TONE!'

                this.$store.dispatch('GETCORPORATIONGIFTEE', giftPayload).then(() => {
                    let self = this
                    if (this.getGiftee && !this.getGiftingError.show) {
                        // this.spinnerToggle()
                        this.user.email = this.user.email.toLowerCase()
                        this.$store.dispatch('SAVEGIFTEE', {giftee: this.user}).then(() => {
                            if (!this.error.show) {
                                this.$store.commit('setCorporateGiftingCode', {giftCode: null})
                                this.$store.commit('setCorporateClientId', {corporateClientId: null})
                                this.$store.commit('setCorporateGiftingCode', {giftCode: null})
                                this.$store.commit('setCorporateGiftInfo', {gift: null})
                                // this.spinnerToggle()
                                this.$swal({
                                    title: 'Registration Success!',
                                    text: displayMsg,
                                    type: 'success',
                                    timer: 4000,
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'sweetalert-lg-signup'
                                }).then(
                                    function () {
                                    },
                                    // handling the promise rejection
                                    function (dismiss) {
                                        if (dismiss === 'timer') {
                                        }
                                    }
                                )
                            } else {
                                // this.spinnerToggle()
                                if (this.error.show) {
                                    // console.log('error', this.error.message)
                                    if (this.error.message.toString().toLowerCase().indexOf('already exist') > -1) {
                                        self.showResetModal = true
                                    } else {
                                        this.$swal({
                                            title: 'An Error occurred while processing the request',
                                            text: this.error.message,
                                            type: 'error',
                                            timer: 3000,
                                            showCancelButton: false,
                                            showConfirmButton: false
                                        }).then(
                                            function () {
                                            },
                                            // handling the promise rejection
                                            function (dismiss) {
                                                if (dismiss === 'timer') {
                                                }
                                            }
                                        )
                                    }
                                }
                            }
                        })
                    } else {
                        this.user.packageId = -1
                        this.$swal({
                            title: 'No gift found for this corporation. Some error occured.',
                            text: '',
                            type: 'error',
                            timer: 4000,
                            showCancelButton: false,
                            showConfirmButton: false
                        }).then(
                            function () {
                            },
                            // handling the promise rejection
                            function (dismiss) {
                                if (dismiss === 'timer') {
                                }
                            }
                        )
                    }
                })
            }
        },
        computed: {...mapGetters([
            'error', 'isUserLoggedIn', 'getAllPlans', 'getGiftee', 'getGiftingError', 'getCorporateGiftingCode', 'getCorporateClientId',
            'getCorporateClient', 'getAllSiteContents', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor',
            'getCorpHeadingColor', 'getCorporateGiftInfo', 'getRequestDecodedData'])
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .set-error{
        border-color: #a94442 !important;
        color:#a94442 !important;
    }
    .StripeElement {
        background-color: white;
        padding: 2em 1em;
        border: 1px solid #ccc;
        box-shadow: 0 1px 3px 0 #e6ebf1;
        -webkit-transition: box-shadow 150ms ease;
        transition: box-shadow 150ms ease;
        height: 34px;
    }
    .float-right.paymentswitch.btn-group {
        margin: 0 0 30px;
    }
    .StripeElement--focus {
        box-shadow: 0 1px 3px 0 #cfd7df;
    }

    .StripeElement--invalid {
        border-color: #fa755a;
    }

    .StripeElement--webkit-autofill {
        background-color: #fefde5 !important;
    }
    .radiowrapper {
        padding: 0 35px 35px;
        color: #f0617d;
    }
    .showmobile{
        display:none;
    }
    .stripeholder {
        position: relative;
    }

    i.fa.fa-lock.overlapstripe {
        position: absolute;
        left: 18px;
        top: 10px;
        font-size: 18px;
        color: #b2b8c7;
    }
    @media (max-width:767px){
        .hidemobile{
            display:none;
        }
        .showmobile{
            display:inherit;
        }
        .signUp .left-content h4 {
            font-size: 14px;
            letter-spacing: 0px;
        }

        .signUp .main-content h2 {
            margin: 15px 0;
            line-height: 20px;
            font-size: 18px;
        }

        .signUp #redeem_pwderrormsg {
            margin-bottom: 8px;
            line-height: 1.3;
            letter-spacing: 1px;
        }

        .signUp .left-content .create-account #redeem_button {
            margin: 0;
        }

        .signUp .right-content .jumbotron {
            padding: 6px;
            margin-top: 7px;
        }

        .signUp .right-content .jumbotron h2 {
            margin: 0;
            font-size: 21px;
        }

        .signUp .right-content .jumbotron p {
            display: none;
        }

        .signUp .right-content .card {
            padding: 10px 10px;
        }

        .signUp .right-content .card .card-block .list-group li {
            font-size: 16px;
            margin: 0 0 10px;
        }

        .signUp .left-content hr {
            display: none;
        }

        .row.margin-top {
            margin-top: 0px;
        }

    }

    /* Media query for mobile viewport */
    @media screen and (max-width: 400px) {
        #paypal-button-container {
            width: 100%;
        }
    }

    /* Media query for desktop viewport */
    @media screen and (min-width: 400px) {
        #paypal-button-container {
            width: 250px;
            display: inline-block;
        }
    }
    body .margin-top {
        margin-top: 89px;
        margin-bottom: 70px;
    }
    body .signUp .right-content .card .card-block .list-group{
        margin-bottom:0px;
    }

    .responsive-table {
        overflow-x: auto; /* Enable horizontal scrolling on small screens */
    }

    table {
        width: 100%;
        border-collapse: collapse;
    }

    th,
    .td1 {
        padding: 8px 12px;
        text-align: left;
        border-bottom: 0px solid #ddd;
        font-size: 16px;
        font-weight: bold;
        color: #2d3139;
    }

    th,
    .td2 {
        padding: 8px 12px;
        text-align: left;
        border-bottom: 0px solid #ddd;
        font-size: 16px;
        color: #2d3139;
    }

    th {
        background-color: #f2f2f2;
    }

    /* Responsive styles */
    @media (max-width: 600px) {
        table,
        thead,
        tbody,
        th,
        td,
        tr {
            display: block;
        }

        thead tr {
            position: absolute; /* Hide table headers */
            top: -9999px;
            left: -9999px;
        }

        tr {
            border: 1px solid #ccc;
            margin-bottom: 10px;
        }

        td {
            border: none;
            border-bottom: 1px solid #eee;
            position: relative;
            padding-left: 50%; /* Make space for data label */
            text-align: left;
        }

        td:before {
            position: absolute;
            top: 6px;
            left: 6px;
            width: 45%;
            padding-right: 10px;
            white-space: nowrap;
            content: attr(data-label);
            font-weight: bold;
        }
    }
</style>



// WEBPACK FOOTER //
// CorporationGiftingBCBS.vue?4b8e1d64